import request from '@/utils/request'

// 保存计划投资
export function savePrjFundPlan(data) {
  return request({
    url: 'admin/portal/prjfundplan/save',
    method: 'post',
    data
  })
}

// 计划投资列表
export function listPrjFundPlan(data) {
  return request({
    url: 'admin/portal/prjfundplan/list',
    method: 'post',
    data
  })
}

// 详情
export function infoPrjFundPlan(id) {
  return request({
    url: 'admin/portal/prjfundplan/info/'+id,
    method: 'get'
  })
}

// 更新
export function updatePrjFundPlan(data) {
  return request({
    url: 'admin/portal/prjfundplan/update',
    method: 'post',
    data
  })
}

// 批量删除
export function delPrjFundPlan(data) {
  return request({
    url: 'admin/portal/prjfundplan/delete',
    method: 'post',
    data
  })
}

